/**
 * The legacy application show screen. Still reachable, deliberately — what moved
 * to manage is the application-detail ENTRY POINTS (dashboard, getting started,
 * payments, program show, benefit history, dependent programs, the beta-home
 * alerts, the guided wizard's post-submit redirect). These still land here:
 *
 *   - the manage screen's temporary Classic View comparison link
 *   - the History page's "Application" tab (`applications/history.gts`) and this
 *     screen's own self-tab
 *   - the reimagined detail page's explicit "View legacy" action
 *   - direct URLs — bookmarks, and the deep links tio-api puts in employee email
 */
export const LEGACY_APPLICATION_SHOW_ROUTE = 'authenticated.tas.applications.show';

/**
 * The single shared TAS application detail screen, and where every
 * application-detail entry point now goes. It is not the only route to a detail
 * screen — see LEGACY_APPLICATION_SHOW_ROUTE above for what still reaches the old
 * one on purpose.
 *
 * This used to be resolved per application by `applicationDetailRoute`, which
 * weighed a feature flag against a set of "manageable" program types. Both inputs
 * are gone: the flag is removed, and the one type outside that set — Type 1,
 * tracking-only — cannot have an application at all (`usesApplication: false` in
 * tio-common's program-builder `PROGRAM_TYPES`), so it never reached an
 * application detail screen. Callers use this constant directly.
 */
export const MANAGE_ROUTE = 'authenticated.tas.applications.manage';
